export default (axios, { cvv, paymentId }) => axios.post('/token/confirm', { cvv, paymentId });
